'use client';

import { useResults } from '@components/Search/hooks/useResults';
import { useProductTags } from '@contexts/ProductTagsContext';
import { AtomicListingContext } from '@contexts/coveo/AtomicListingContext';
import { analytics } from '@lib/analytics/page-events';
import { mapContentfulTags } from '@lib/util/tags';
import { useContext, useEffect } from 'react';

import { getProductCardTabletClasses } from '@components/Product/productCardTabletStyles';
import { ProductRow as ProductRowUI } from '@components/PublisherProfile/ProductRow';
import { HeadlessProductCardWrapper } from '@components/Search/HeadlessProductCardWrapper';

export const PublisherAssets = ({
  gridCols,
  className,
}: {
  gridCols: number;
  className?: string;
}) => {
  const { searchEngine } = useContext(AtomicListingContext);
  const { results: resultState } = useResults(searchEngine);
  const productTags = useProductTags();
  const mappedProductTags = productTags ? mapContentfulTags(productTags) : [];

  useEffect(() => {
    if (resultState?.results && resultState.results.length > 0) {
      analytics.pushPublisherProductsImpressionEvent(
        resultState.results.map((result, index) => ({
          id: result.raw.ec_product_id as string,
          name: result.raw.ec_name as string,
          brand: result.raw.publisher_name as string,
          category: result.raw.category_slug as string,
          position: index + 1,
          price: (result.raw.price as string | number) || '0.00',
        }))
      );
    }
  }, [resultState?.results]);

  if (!resultState?.results || resultState?.results.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <ProductRowUI gridCols={gridCols}>
        {resultState.results.map((result, index) => (
          <HeadlessProductCardWrapper
            key={result.raw.ec_product_id as string}
            context={AtomicListingContext}
            result={result}
            allProductTags={mappedProductTags}
            className={getProductCardTabletClasses(
              index,
              resultState.results.length
            )}
          />
        ))}
      </ProductRowUI>
    </div>
  );
};
